import { parse as queryfilterFromString } from '@gonfalon/queryfilter/parser';
import type { PostContextsParams } from '@gonfalon/rest-api/types';

import type { UIContextsView } from '../types/types';

export function parseUIContextViewFromAPI(api: PostContextsParams) {
  const ui: UIContextsView = {};
  if (api.filter) {
    const parse = queryfilterFromString(api.filter);
    if (parse.ok) {
      ui.filter = parse.val;
    }
  }
  return ui;
}
